export function classes(...classes: readonly unknown[]): string | undefined {
  return classes.flat(1).filter(Boolean).map(String).join(' ') || undefined;
}
